module.exports = __webpack_public_path__ + "static/media/collapse.f174bc69.svg";